import { BoxScene } from "./Scene";
import React, { Suspense, useEffect } from "react";
import { Canvas } from "@react-three/fiber";
import { PleaseWait } from "./PleaseWait";
import { state } from "./store";
import { ConfiguratorProvider } from "./context/context";
import { useGLTF } from "@react-three/drei";

const ThreeBoxComponent = ({boxData,...props}) => {

  const {links,settings}=boxData

  state.links = links

  state.replayAnim=settings.replayAnim

  state.startTimeout=settings.startTimeout

  state.boxOpen=false

  return (
    <>
    <ConfiguratorProvider>
      <Suspense fallback={<PleaseWait />}>
        <Canvas className="canvas">
          <BoxScene />
        </Canvas>
      </Suspense>
      </ConfiguratorProvider>
    </>
  );
};

export { ThreeBoxComponent };

useGLTF.preload("./scene.glb");